// extracted by mini-css-extract-plugin
export default {"intro-card-code-wrap":"CleanCode_intro-card-code-wrap__yFyod","intro-card-code-indented":"CleanCode_intro-card-code-indented__YCmhq","code-color":"CleanCode_code-color__1O6en"};